import React, { useState, useEffect } from 'react'
import SettingsCard from 'egi/app/Settings/components/SettignsCard/SettingsCard'
import OperationalLimit from 'egi/app/OperationalLimit/views/OperationalLimit'
import { Row, Button, Pagination } from 'antd'
import SettingsHistory from 'egi/app/Settings/components/SettignsHistory/SettingsHistory'
import { OperationalShowHistory } from '../../components/ShowLimitHistory/ShowLimitHistory'
import ConfigurationsRepository, { ILogs } from 'egi/repositories/ConfigurationsRepository'
import { useSelectedProduct } from 'hooks'

function OperationalLimitSettings () {
  const [visible, setVisible] = useState<boolean>(false)
  const [logs, setLogs] = useState<ILogs[]>([])
  const [totalDocs, setTotalDocs] = useState<number>(0)
  const [params, setParams] = useState({ page: 1, limit: 8 })
  const [loading, setLoading] = useState({ history: false })
  const { _id: productId } = useSelectedProduct()

  useEffect(() => {
    async function fetchHistory () {
      setLoading({ history: true })
      try {
        const response = await ConfigurationsRepository.getOperationalLimitHistory(productId, { params })
        setLogs(response?.data?.data?.logs?.docs || [])
        setTotalDocs(response?.data?.data?.logs?.totalDocs || 0)
      } catch {
        setLogs([])
        setTotalDocs(0)
      }
      setLoading({ history: false })
    }
    fetchHistory()
  }, [productId, params])

  return (
    <>
      <SettingsCard.Header
        title="Limite operacional"
        description={
          <>
            <p>
              Configure aqui os valores para o <b>limite operacional</b> da proposta.
              Ao fazer alguma alteração os valores refletirão na proposta.
            </p>
          </>
        }
      />

      <SettingsCard>
        <Row justify="space-between" align="middle" className="mb-2">
          <SettingsCard.title>
            Limite operacional
          </SettingsCard.title>
          <Button onClick={() => setVisible(true)} type="primary">
            Histórico
          </Button>
        </Row>
        <SettingsCard.description className="mb-4">
        Se os valores excederem os limites estabelecidos para cada alçada, será necessária a aprovação de crédito correspondente.
        </SettingsCard.description>
        <OperationalLimit/>
      </SettingsCard>

      <SettingsHistory
        visible={visible}
        onChangeVisible={() => setVisible(false)}
        title="Histórico de alterações"
        description="Aqui você pode conferir as alterações feitas nos limites operacionais."
      >
        <OperationalShowHistory
          history={logs}
          historyLoading={loading.history}
        />
        <Pagination
          total={totalDocs}
          current={params.page}
          onChange={page => setParams(prev => ({ ...prev, page }))}
          pageSize={Number(params.limit)}
        />
      </SettingsHistory>
    </>
  )
}

export default OperationalLimitSettings
